module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "confirmation-response"
    }
  }, [_c('img', {
    attrs: {
      "id": "confirmation-tooth",
      "src": require("../../images/confirmation-tooth.png")
    }
  }), _vm._v(" "), (_vm.inactiveUser) ? _c('div', [_c('h1', {
    staticClass: "thanks"
  }, [_vm._v("\n            Sprawdź pocztę i aktywuj konto, aby potwierdzić rezerwację wizyty.\n        ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("\n            Po aktywacji konta wybrany przez Ciebie termin musi zostać potwierdzony przez placówkę,\n            gdy się to stanie otrzymasz od nas powiadomienie.\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("\n            W wiadomości aktywacyjnej wysłaliśmy również Twój login, który posłuży\n            do logowania się do konta pacjenta.\n        ")])]) : (_vm.$store.facility.require_doctor_reservation_approval) ? _c('div', [_c('h1', {
    staticClass: "thanks"
  }, [_vm._v("Dziękujemy za rezerwację wizyty w naszym gabinecie")]), _vm._v(" "), _vm._m(1)]) : _c('div', [_c('h1', {
    staticClass: "thanks"
  }, [_vm._v("Dziękujemy za rezerwację wizyty w naszym gabinecie")])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn-outline-green",
    on: {
      "click": _vm.goToIndex
    }
  }, [_vm._v("UMÓW KOLEJNĄ WIZYTĘ")]), _vm._v(" "), _c('button', {
    staticClass: "btn-outline-blue",
    on: {
      "click": _vm.goToPatientsPortal
    }
  }, [_vm._v("PRZEJDŹ DO SWOJEGO KONTA")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "info"
  }, [_vm._v("\n            Aby placówka mogła potwierdzić Twoją wizytę, "), _c('span', {
    staticClass: "stress"
  }, [_vm._v("kliknij w link aktywacyjny")]), _vm._v(",\n            który został do Ciebie wysłany na wskazany adres e-mailowy. "), _c('br'), _vm._v("\n            Jeśli nie widzisz wiadomości w skrzynce odbiorczej, sprawdź skrzynkę SPAM.\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "info"
  }, [_vm._v("Zarezerwowany termin musi zostać potwierdzony przez placówkę."), _c('br'), _vm._v("\n        Na wskazany adres e-mailowy otrzymasz powiadomienie o akceptacji terminu."), _c('br'), _vm._v("\n        Jeśli nie widzisz wiadomości w skrzynce odbiorczej, sprawdź skrzynkę SPAM.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1b9fc7a8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfirmationResponse.vue
// module id = 203
// module chunks = 0